module.exports = __webpack_public_path__ + "static/media/sample.d9061d3d.mp4";